
import { BadgeCreate } from './BadgeCreate';
import { BadgeList } from './BadgeList';

export default {
    list: BadgeList,
    create: BadgeCreate
};
